const discountType = {
  absolute: 'absolute',
  percentage: 'percentage',
  code: 'code',
}
export default discountType
